import React ,{useState , useEffect}from 'react'
import { Container, Row, Col, Form, Button, ButtonGroup, Card, Modal } from 'react-bootstrap'
import PageTitle from '../components/common/PageTitle'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import api from '../api/api'
import swal from 'sweetalert';
import './UsersManagement.css'

const UsersManagement = () => {

const navigate = useNavigate()
    const [toggle,setToggle] = useState(false)

    const [userUid,setUserUid] = useState('')
    const [sensorUid,setSensorUid] = useState('')

    const [users,setUsers] = useState([])

    const [SearchEmail, setSearchEmail] = useState('');
    const [SearchName, setSearchName] = useState('');

    const { t } = useTranslation();


    const getMyUsers = async () => {
        await api.get('/supplier/get-users')
        .then(response =>{
            let usersList = response.data.users
            setUsers(usersList)
        }).catch(err =>{
            console.error(err)
        })
    }
    const [mySensors, setMySensors] = useState([])


    const getMySensors = async () => {
        await api.get('/supplier/get-sensors')
            .then(response => {
                let sensorsData = response.data.sensors
                setMySensors(sensorsData)
            }).catch(err => {
                console.error(err)
            })
    }

    useEffect(()=>{
        getMySensors()
        getMyUsers()

    },[])
    // Active/Desactive Users Accounts

    const desactivateUser = (userUid) => {
        let data = {
            user_uid: userUid
        }
        api.post('/supplier/desactivate-user', data)
            .then(response => {
                if (response.data.type == "success") {
                    swal(t("user_desactivated_success"), {
                        icon: "success",
                    });
                    getMyUsers();
                }
                if (response.data.type && response.data.type == "danger") {
                    swal({
                        icon: 'error',
                        title: t('Oops...'),
                        text: t('error_desactivate_user')
                    })
                    return false;
                }
            }).catch(error => {
                swal({
                    icon: 'error',
                    title: t('Oops...'),
                    text: t('error_desactivate_user')
                })
            })
    }

    const activateUser = (userUid) => {
        let data = {
            user_uid: userUid
        }
        api.post('/supplier/activate-user', data)
            .then(response => {
                if (response.data.type == "success") {
                    swal(t("user_activated_success"), {
                        icon: "success",
                    });
                    getMyUsers();
                }
                if (response.data.type && response.data.type == "danger") {
                    swal({
                        icon: 'error',
                        title: t('Oops...'),
                        text: t('error_activate_user')
                    })
                    return false;
                }
            }).catch(error => {
                swal({
                    icon: 'error',
                    title: t('Oops...'),
                    text: t('error_activate_user')
                })
            })
    }



    const filteredUsers = users.filter(user => {
        if(SearchName !== ''){
            return (
              user.name.toLowerCase().includes(SearchName.toLowerCase())
            )
        }
        if(SearchEmail !== ''){
            return (
                user.email.toLowerCase().includes(SearchEmail.toLowerCase())
              )
        }
        return user
    })


    const selectUser = (userUid) => {
        navigate(`/admin/user/${userUid}`)
    }

        // Delete Users Handle

        const handleDelete = async userUid => {

            let data = {
                user_uid: userUid,
            }
            return await api.delete('/admin/delete-user', { data: data })
                .then(response => {
                    if (response.data.type && response.data.type == "danger") {
                        swal({
                            title: `${t('cannot_delete')}`,
                            icon: "warning",
                        });
                        return false;
                    }
                    if (response.data.type == "success") {
                        getMyUsers()
                        return true;
                    }
                    return false;
                }).catch(error => {
                    swal({
                        title: `${t('cannot_delete')}`,
                        icon: "error",
                        text: t('Error')

                    });
                    return false;
                })
        }

        const confirmDelete = userUid => {

            swal({
                title: `${t('are_you_sure')}`,
                text: `${t('confirm_delete')}`,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then(async (Delete) => {
                    if (Delete) {
                        const deleted = await handleDelete(userUid)
                        if (deleted) {
                            swal(`${t('delete_success_user')}`, {
                                icon: "success",
                            });
                        }
                    }
                }).catch(error => {
                    swal({
                        title: `${t('cannot_delete')}`,
                        icon: "error",
                        text: t('Error')

                    });
                })

        }
        const assignSensorToUser = (userUid,sensorUid) =>{
            let data ={
                user_uid : userUid,
                sensor_uid : sensorUid
            }
            api.post('/supplier/assign-sensor',data)
            .then(response =>{
                if(response.data.type === 'success'){
                    swal(`${t('sensor_updated')}`, {
                        icon: "success",
                    });
                    setToggle(false)
                    resetForm()
                    getMyUsers()
                }
                if(response.data.type === 'danger'){
                    swal({
                        icon: 'error',
                        title: t('Oops...'),
                        text: t('Error')
                    })
                    resetForm()

                }
            }).catch(err=>{
                swal({
                    icon: 'error',
                    title: t('Oops...'),
                    text: t('Error')
                })
            })
        }

        const resetForm = () => {
            setTimeout(()=>{
                setUserUid('')
                setSensorUid('')

            },1000)
        }
        const editSensorIdUser = (sensorSelectedUid) => {
            let userid = null;

            mySensors.map(item =>{
                if(item.uid === sensorSelectedUid){
                    userid = item.user_id;
                }
            })

            let hasNotSensor = users.length;

            users.map(user =>{
                if(user.id === userid){
                    setUserUid(user.uid)
                    hasNotSensor = hasNotSensor - 1 ;
                }
            })
            if(hasNotSensor == users.length){
                setUserUid("")
            }

        }



  return (
    <>
    <Container className="supplier-users-page">
        <Row noGutters className="page-header py-4 supusers-header">
            <PageTitle
                sm="4"
                title={t('list_users')}
                subtitle={t('list_users')}
                className="text-sm-left"
            />
        </Row>

        <Card className="supusers-toolbar-card">
            <Card.Body>
                <Row className="supusers-search-row">
                    <Col className="supusers-search-group">
                        <i className="fas fa-magnifying-glass supusers-search-icon" aria-hidden="true" />
                        <Form.Control
                            value={SearchName}
                            onChange={(e) => setSearchName(e.target.value)}
                            id="search-name"
                            placeholder={t('search_by_name')} />
                    </Col>
                    <Col className="supusers-search-group">
                        <i className="fas fa-magnifying-glass supusers-search-icon" aria-hidden="true" />
                        <Form.Control
                            value={SearchEmail}
                            onChange={(e) => setSearchEmail(e.target.value)}
                            id="search-email"
                            placeholder={t('search_by_email')} />
                    </Col>
                </Row>
                <div className="supusers-actions mt-3">
                    <Button variant="outline-primary" onClick={() => navigate('/supplier/add-user')}>
                        <i className="fas fa-plus me-2" aria-hidden="true" />
                        {t('add_user')}
                    </Button>
                    <Button variant="outline-primary" onClick={() => setToggle(true)}>
                        <i className="fas fa-link me-2" aria-hidden="true" />
                        {t('assign_sensor')}
                    </Button>
                </div>
            </Card.Body>
        </Card>

        <Card className="supusers-content-card">
            <div className="supusers-table-wrap">
            <table className="table mb-0 text-center">
                <thead>
                    <tr>
                        <th scope="col">{t('name')}</th>
                        <th scope="col">{t('email')}</th>
                        <th scope="col">{t('num')}</th>
                        <th scope="col">{t('offer_type')}</th>
                        <th scope="col">{t('status')}</th>
                        <th scope="col">{t('Actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        filteredUsers.length === 0 ? (
                            <tr>
                                <td colSpan={6} className="supusers-table-empty">
                                    <i className="fas fa-users" aria-hidden="true" />
                                    <p className="mb-0 mt-2">{t('no_data', { defaultValue: 'No data' })}</p>
                                </td>
                            </tr>
                        ) : filteredUsers.map(user => {
                           let offerType = ""
                            if(user.offer_type === "2"){
                                offerType = t('Premium')
                            } if(user.offer_type === "1"){
                                offerType = t('Freemium')
                            }

                           return (
                                <tr key={user.uid}>
                                    <td>{user.name}</td>
                                    <td>{user.email}</td>
                                    <td>{user.phone_number ? user.phone_number : "-"}</td>
                                    <td>{offerType}</td>
                                    <td>
                                        {user.deleted_at != null ? (
                                            <span className="supusers-status-pill">{t('deleted_user')}</span>
                                        ) : user.is_valid != 1 ? (
                                            <span className="supusers-status-pill">{t('not_active')}</span>
                                        ) : null}
                                    </td>
                                    <td>
                                        {
                                            user.deleted_at == null && user.is_valid == 1 ? (
                                                <ButtonGroup size="sm" className="mr-2">
                                                    <Button title={t('edit')} onClick={() => selectUser(user.uid)}>
                                                        <i className="material-icons">&#xe3c9;</i>
                                                    </Button>
                                                    {
                                                        user.is_active == 1 ? (
                                                            <Button title={t('deactivate')} onClick={() => desactivateUser(user.uid)} variant="warning">
                                                                <i className="material-icons" style={{ color: 'white' }}>&#xe510;</i>
                                                            </Button>
                                                        ) : (
                                                            <Button title={t('activate')} onClick={() => activateUser(user.uid)} variant="success">
                                                                <i className="material-icons" style={{ color: 'white' }}>&#xe7fd;</i>
                                                            </Button>
                                                        )
                                                    }
                                                    <Button title={t('delete')} onClick={() => confirmDelete(user.uid)} variant="danger">
                                                        <i className="material-icons" style={{ color: 'white' }}>&#xe872;</i>
                                                    </Button>
                                                </ButtonGroup>
                                            ) : null
                                        }
                                    </td>
                                </tr>

                            )
                        })
                    }

                </tbody>
            </table>
            </div>

        </Card>
    </Container>
    <Modal className="supusers-modal" centered show={toggle} onHide={() => {resetForm();setToggle(false)}}>

                <Modal.Header closeButton className="d-flex justify-content-between align-items-center">
                    <div>
                    {t('assign_sensor_to_user')}
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",

                        }}
                    >
                        <Button
                            className="mb-2 mr-1 btn btn-success"
                            onClick={() => assignSensorToUser(userUid,sensorUid)}
                        >
                            <i className="fa fa-check mx-2"></i>
                            {t('save')}
                        </Button>
                        <Button
                            className="mb-2 mr-1 btn btn-danger"
                            onClick={() => {resetForm();setToggle(false)} }
                        >
                            <i className="fa fa-times mx-2"></i>
                            {t('cancel')}
                        </Button>
                    </div>
                </Modal.Header>
                <Modal.Body>
                <Row className='d-flex justify-content-center border-bottom'>
                    <Col lg='6' md='8' sm='8'>

                    <label htmlFor="sensors">{t('select_sensor')}</label>

                    <Form.Group>
                           <Form.Select
  id="sensors"
  value={sensorUid}
  onChange={(e) => {setSensorUid(e.target.value);editSensorIdUser(e.target.value)}}
>
  <option value="">{t('select_sensor')}</option>
  {mySensors.map(sensor => (
    <option key={sensor.uid} value={sensor.uid}>{sensor.code}</option>
  ))}
</Form.Select>
                    </Form.Group>
                    </Col>
                </Row>
                {
                    sensorUid !== ''
                    ?
                    <Row className='d-flex justify-content-center  pt-2'>
                            <Col lg='6' md='8' sm='8' className="">
                            <Form.Group>
                            <label htmlFor="users">{t('select_user')}</label>

                                    <Form.Select
                                    id="users"
                                    value={userUid}
                                    onChange={(e) => {setUserUid(e.target.value);}}
                                >
                                    <option value="">{t('select_user')}</option>

                                    {
                                        users.map(user =>{
                                            if(user.is_valid == 1 && user.is_active == 1){
                                                return <option key={user.uid} value={user.uid}>{user.name}</option>
                                            }
                                            return null
                                        })
                                    }
                                </Form.Select>

                            </Form.Group>
                        </Col>
                    </Row>
                    :
                    null

                }
                </Modal.Body>
            </Modal>

</>
  )
}

export default UsersManagement
